import { gql } from '@apollo/client';

export default gql`
  query UserReviewsCount($userId: Int) {
    allProductReviews(condition: { userId: $userId }) {
      totalCount
    }
  }
`;
